module.exports = __webpack_public_path__ + "img/logo.13a8988b.png";